import Vue from 'vue'
import VueRouter from 'vue-router'

// Auditoria Views
import AuditoriaLogin from '@/views/auditoria/Login.vue'
import AuditoriaLayout from '@/views/auditoria/Layout.vue'
import AuditoriaDashboard from '@/views/auditoria/Dashboard.vue'
import AuditoriaConcursos from '@/views/auditoria/Concursos.vue'
import AuditoriaInscricoes from '@/views/auditoria/Inscricoes.vue'
import AuditoriaDocumentosInscricao from '@/views/auditoria/DocumentosInscricao.vue'

Vue.use(VueRouter)

const auditoriaRoutes = [
  {
    path: '/auditoria',
    redirect: '/auditoria/login'
  },
  {
    path: '/auditoria/login',
    name: 'auditoria-login',
    component: AuditoriaLogin,
    meta: {
      requiresGuest: true,
      title: 'Login Auditoria'
    }
  },
  {
    path: '/auditoria/dashboard',
    component: AuditoriaLayout,
    meta: {
      requiresAuthAuditor: true,
      title: 'Dashboard Auditoria'
    },
    children: [
      {
        path: '',
        name: 'auditoria-dashboard',
        component: AuditoriaDashboard,
        meta: {
          title: 'Início',
          icon: 'fas fa-home'
        }
      },
      {
        path: 'concursos',
        name: 'auditoria-concursos',
        component: AuditoriaConcursos,
        meta: {
          title: 'Concursos',
          icon: 'fas fa-clipboard-list'
        }
      },
      {
        path: 'inscricoes',
        name: 'auditoria-inscricoes',
        component: AuditoriaInscricoes,
        meta: {
          title: 'Inscrições',
          icon: 'fas fa-file-alt'
        }
      },
      {
        path: 'documentos-inscricao',
        name: 'auditoria-documentos-inscricao',
        component: AuditoriaDocumentosInscricao,
        meta: {
          title: 'Documentos de Inscrição',
          icon: 'fas fa-folder-open'
        }
      }
    ]
  }
]

export default auditoriaRoutes

